// components/DownloadExcelComponent.tsx
import { DownloadIcon } from "@chakra-ui/icons";
import {
  IconButton,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { useContext, useState } from "react";
import { appRequest } from "routes";

const DownloadExcelComponent = ({ type, selectedLevel, isDuplicate, isException, ...props }: any) => {
  const { workflowProcess, accountDetails, startDate, endDate } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const downloadExcel = async () => {
    if (!workflowProcess?.processName) {
      toast({
        title: "Error",
        description: "Workflow process not selected",
        status: "error",
        duration: 3000,
        isClosable: true
      });
      return;
    }

    setIsLoading(true);
    try {
      // 1. Call your API
      const response: any = await appRequest("document", "downloadExcel", {
        level: selectedLevel || accountDetails.level,
        status: isException ? undefined : type,
        processName: workflowProcess.processName,
        processType: workflowProcess?.processType,
        isException: isException,
        isDuplicate: isDuplicate,
        startDate: startDate,
        endDate: endDate,
        isPendingToSubmit: isException ? true : undefined,
      });

      // 2. Extract base64 (supports both formats)
      const base64String = response?.base64 || response?.data?.base64 || response;
      if (!base64String || typeof base64String !== "string") {
        throw new Error("Invalid response: no Excel data");
      }

      const base64 = base64String.includes(",")
        ? base64String.split(",")[1]
        : base64String;

      console.log('teh base64', base64)
      // 3. Convert to Blob
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 4. Trigger download
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoices_${type}_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`; // e.g., Invoices_pending_2025-10-26.xlsx

      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast({
        title: "Success",
        description: "Excel downloaded successfully",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error: any) {
      console.error("Download failed:", error);
      toast({
        title: "Download Failed",
        description: error.message || "Please try again",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Tooltip label={`Download ${type} invoices as Excel`} hasArrow>
      <IconButton
        onClick={downloadExcel}
        aria-label={`Download ${type} Excel`}
        title={`Download ${type} Excel`}
        icon={<DownloadIcon />}
        colorScheme="green"
        variant="solid"
        size="sm"
        isLoading={isLoading}
        isDisabled={isLoading}
        {...props}
      />
    </Tooltip>
  );
};

export default DownloadExcelComponent;